<template>
  <div class="rate-table one" :class="[{ look: mode == 'base' }, 'showNum' + (cssNum - 1)]">
    <div class="head" id="head">
      <div class="td first-td">
        <div class="name-key">险种名称</div>
      </div>
      <div class="td sec-td">方案名称</div>
      <div class="td" v-for="(item, i) in headList" :key="i">{{ item.name }}</div>
      <div class="td" v-if="mode != 'base' || type == 2">服务费分配</div>
      <div class="td commission">
        首年(%)
        <Icon type="md-add-circle" color="#236DFF" size="24" @click="addYear({ index: 1 })" v-if="pageType == 'productLibrary' && showNum == 1" />
      </div>
      <!-- 运营配的活动 -->
      <div
        class="td"
        style="color: #fc5426"
        v-if="
          (type == 2 || (userType == 2 && mode == 'base')) && component != 'commissionTemplate' && data.activityInfoList && data.activityInfoList[0].mode == 1
        "
      >
        <i class="huo">活</i>活动①
      </div>
      <!-- 商户配的活动 -->
      <div
        class="td"
        style="color: #fc5426"
        v-if="data.merchantActivity && (type == 2 || (userType == 2 && mode == 'base')) && component != 'commissionTemplate'"
      >
        <i class="huo">活</i>活动{{
          data && data.merchantActivity && data.activityInfoList && data.activityInfoList.filter(item => item.mode != 2).length && data.activityInfoList.length
            ? '②'
            : '①'
        }}
      </div>
      <div class="td commission" v-if="data.isDynamicRate">首年发放(%)</div>
      <div class="td commission" v-if="data.isDynamicRate">首年后置(%)</div>
      <!-- 历史费率展示 -->
      <div class="td" v-for="(item, i) in activityList" :key="'act' + i"><i class="huo">活</i>首年活动</div>
      <!-- 第2年及后面的 -->
      <div
        class="td commission"
        v-for="bean in yearList"
        :key="'year' + bean.index"
        :class="{ 'last-td': bean.index == showNum && bean.index > 5 && pageType == 'productLibrary' }"
      >
        <!-- 最后一年且大于5年需要显示至交费期，产品库才可修改交费期 -->
        <template v-if="bean.index == showNum && bean.index > 5">
          <template v-if="pageType == 'productLibrary'">
            {{ bean.text }}%
            <Checkbox v-if="setCommissionYear" v-model="untilLast" @on-change="setFullYear(bean)">至交费期满</Checkbox>
          </template>
          <span v-else-if="untilLast">{{ bean.text }}至交费期满(%)</span>
          <span v-else>{{ bean.text }}(%)</span>
        </template>
        <span v-else>{{ bean.text }}(%)</span>
        <Icon
          type="md-close-circle"
          color="#F26868"
          size="24"
          @click="delYear(bean)"
          v-if="pageType == 'productLibrary' && bean.index == showNum && !untilLast &&  setCommissionYear"
        />
        <Icon
          type="md-add-circle"
          color="#236DFF"
          size="24"
          @click="addYear(bean)"
          v-if="pageType == 'productLibrary' && bean.index == showNum && !untilLast &&  setCommissionYear"
        />
      </div>
      <!-- <div class="td last-td big-td" v-if="mode!='base'&&organShow">操作</div> -->
    </div>
    <div class="body" id="body">
      <div class="empty-text" v-if="!dataBak.commissionItems || dataBak.commissionItems.length == 0"><slot name="emptyText">暂无数据</slot></div>
      <div class="row-child topRow1" v-for="(item, x) in dataBak.commissionItems" :key="x" :id="'a' + item.productCode + item.gradeCode">
        <div class="td first-td">
          <div class="productName-box">
            <div class="tag fu" v-if="item.isMain === '0'">附</div>
            {{ item.productName }}
          </div>
          <span v-if="dataBak.commissionItems.length > 1 && sort && !item.edit">
            <Icon @click="upData(1, x)" :class="{ 'disabled': x == 0 }" type="md-arrow-up" />
            <Icon @click="downData(1, x)" :class="{ 'disabled': x == dataBak.commissionItems.length - 1 }" type="md-arrow-down" />
          </span>
        </div>
        <div class="row-box">
          <div class="row-child" :class="{ 'top-row': mode != 'base' }" v-for="(item2, ii) in item.programBaseList" :key="ii">
            <div class="td full-td sec-td">
              {{ item2.name }}
              <span v-if="item.programBaseList.length > 1 && sort && !item.edit">
                <Icon @click="upData(2, x, ii)" :class="{ 'disabled': ii == 0 }" type="md-arrow-up" />
                <Icon @click="downData(2, x, ii)" :class="{ 'disabled': ii == item.programBaseList.length - 1 }" type="md-arrow-down" />
              </span>
            </div>
            <div class="td full-td" v-for="(head, iii) in headList" :key="iii">
              <tooltip :txtInfo="getKeyText(item2.factors, head.code)" v-if="getKeyText(item2.factors, head.code).length > 30"></tooltip>
              <span v-else>{{ getKeyText(item2.factors, head.code) }}</span>
            </div>
            <div class="row-box" v-if="type == 1 || type == 0">
              <div class="row-child" v-for="(item4, iiii) in item2.organizationList" :key="iiii" :class="{ hide: iiii == 2 && type == 0 }">
                <template v-if="mode != 'base'">
                  <div class="td" v-if="iiii == 0 && (type == 0 || mode == 'base')">基准费率</div>
                  <div class="td" v-if="iiii == 1 && type == 0">商户</div>
                  <div class="td" v-if="iiii == 0 && type == 1">上级机构</div>
                  <div class="td" v-if="iiii == 1 && type == 1">应用机构</div>
                  <div class="td" v-if="iiii == 2 && type == 1">上级剩余</div>
                </template>
                <!-- 首年 -->
                <rateTableItem
                  :list="item2.organizationList"
                  listKey="organizationList"
                  :item="item4"
                  dataKey="0"
                  :mode="mode"
                  :edit="item.edit"
                  :index="iiii"
                ></rateTableItem>
                <!-- 商户活动 只在商品库中显示 -->
                <div class="td" v-if="userType == 2 && mode == 'base' && data.activityInfoList && data.activityInfoList[0].mode == 1" style="color: #fc5426">
                  <span v-if="item4.merAct && item4.merAct.value && item4.merAct.value!='0'">+</span>
                  <span>{{ item4.merAct && item4.merAct.value!='0' ? item4.merAct.value : '-' }}</span>
                  <span v-if="item4.merAct && item4.merAct.value && item4.merAct.value!='0'">%</span>
                </div>
                <template v-if="data.isDynamicRate">
                  <!-- 首年发放 -->
                  <rateTableItem
                    :list="item2.organizationList"
                    listKey="organizationList"
                    :item="item4"
                    dataKey="0"
                    :mode="mode"
                    :edit="item.edit"
                    :index="iiii"
                    valueKey="afterPostfRateValue"
                  ></rateTableItem>
                  <!-- 首年后置 -->
                  <rateTableItem
                    :list="item2.organizationList"
                    listKey="organizationList"
                    :item="item4"
                    dataKey="0"
                    :mode="mode"
                    :edit="item.edit"
                    :index="iiii"
                    valueKey="postfRateValue"
                  ></rateTableItem>
                </template>
                <!-- 历史费率活动展示 -->
                <div class="td" v-for="(item, i) in activityList" :key="'act' + i">
                  {{ getActivityNum(item4.agencyActs, item) }}
                </div>
                <!-- 第二年及后面 -->
                <rateTableItem
                  v-show="i5 != 0"
                  v-for="(bean, i5) in item4.commissionInfoBeans"
                  :key="'item' + i5"
                  :list="item2.organizationList"
                  listKey="organizationList"
                  :dataKey="i5"
                  :mode="mode"
                  :edit="item.edit"
                  :index="iiii"
                  :class="{ 'last-td': bean.commissionIndex == showNum && bean.commissionIndex > 5 && pageType == 'productLibrary' }"
                ></rateTableItem>
              </div>
            </div>
            <div class="row-box" v-else>
              <div class="row-child" v-for="(item4, iiii) in item2.groupList" :key="iiii">
                <div class="td" v-if="iiii == 0 && mode != 'base'">所属机构</div>
                <div class="td" v-if="(iiii == 1 && mode != 'base') || (iiii == 0 && mode == 'base')">团队长</div>
                <div class="td" v-if="(iiii == 2 && mode != 'base') || (iiii == 1 && mode == 'base')">团员</div>
                <div class="td" v-if="iiii == 3 && mode != 'base'">机构剩余</div>
                <!-- 首年 -->
                <rateTableItem :list="item2.groupList" listKey="groupList" dataKey="0" :mode="mode" :edit="item.edit" :index="iiii"></rateTableItem>
                <!-- 运营配的活动 -->
                <div class="td" v-if="component != 'commissionTemplate' && data.activityInfoList && data.activityInfoList[0].mode == 1" style="color: #fc5426">
                  <span v-if="item4.agencyAct && item4.agencyAct.value && item4.agencyAct.value!='0'">+</span>
                  <span>{{ item4.agencyAct && item4.agencyAct.value!='0' ? item4.agencyAct.value : '-' }}</span>
                  <span v-if="item4.agencyAct && item4.agencyAct.value && item4.agencyAct.value!='0'">%</span>
                </div>
                <!-- 商户配的活动 -->
                <div class="td" v-if="data.merchantActivity && component != 'commissionTemplate'" style="color: #fc5426">
                  <span v-if="item4.merchantActivity && item4.merchantActivity.value && item4.merchantActivity.value!='0'">+ </span>
                  <span>{{ item4.merchantActivity && item4.merchantActivity.value && item4.merchantActivity.value!='0' ? item4.merchantActivity.value : '-' }}</span>
                  <span v-if="item4.merchantActivity && item4.merchantActivity.value && item4.merchantActivity.value!='0'">%</span>
                </div>
                <template v-if="data.isDynamicRate">
                  <!-- 首年发放 -->
                  <rateTableItem
                    :list="item2.groupList"
                    listKey="groupList"
                    dataKey="0"
                    :mode="mode"
                    :edit="item.edit"
                    :index="iiii"
                    valueKey="afterPostfRateValue"
                  ></rateTableItem>
                  <!-- 首年后置 -->
                  <rateTableItem
                    :list="item2.groupList"
                    listKey="groupList"
                    dataKey="0"
                    :mode="mode"
                    :edit="item.edit"
                    :index="iiii"
                    valueKey="postfRateValue"
                  ></rateTableItem>
                </template>
                <!-- 历史费率活动展示 -->
                <div class="td" v-for="(item, i) in activityList" :key="'act' + i">
                  {{ getActivityNum(item4.agencyActs, item) }}
                </div>
                <!-- 第二年及后面 -->
                <rateTableItem
                  v-show="i5 != 0"
                  v-for="(bean, i5) in item4.commissionInfoBeans"
                  :key="'item' + i5"
                  :list="item2.groupList"
                  listKey="groupList"
                  :dataKey="i5"
                  :mode="mode"
                  :edit="item.edit"
                  :index="iiii"
                  :class="{ 'last-td': bean.commissionIndex == showNum && bean.commissionIndex > 5 && pageType == 'productLibrary' }"
                ></rateTableItem>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="td full-td last-td btn-td big-td start-td" v-if="mode!='base'&&organShow">
          <div class="btn" v-if="!item.edit" @click="editItem(item)">
            编辑
          </div>
          <div class="btn" v-if="item.edit" @click="save()">保存</div>
          <div class="btn" v-if="item.edit" @click="cancel(item)">取消</div>
        </div> -->
      </div>
    </div>

    <!-- 确认弹窗 -->
    <confirm-modal ref="confirmModal"></confirm-modal>
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal';
import tooltip from '@/components/commons/tooltip';
import rateTableItem from './rateTableItem';
export default {
  components: { tooltip, rateTableItem, confirmModal },
  props: {
    data: null,
    type: null, //1:机构 2：团队
    mode: null, //模式 one 单产品费率 其他 费率模板
    dataType: {
      //数据返回格式
      // 默认平铺展开返回
      type: String,
      default: '1'
    },
    sort: {
      //是否允许排序
      type: Boolean,
      default: false
    },
    setCommissionYear: {
      //是否允许排序
      type: Boolean,
      default: true
    },
    sortType: {
      //排序方式 上游基础费用配置采用新排序
      type: String,
      default: 'normal'
    },
    pageType: null,
    component: null
  },
  data() {
    return {
      userType: '', //用户类型1、运营 2、商户 3、下级机构 4、业务员
      showNum: 5,
      yearList: [],
      cssNum: 5,
      disabledAll: false,
      untilLast: false, //是否交费期满
      isAll: false,
      dataBak: {}, // 备份 对比数据用 当前绑定数据
      dataBak2: {}, // 备份 对比数据用
      headList: [],
      activityList: [],
      list: []
    };
  },
  watch: {
    data() {
      const curData = JSON.parse(JSON.stringify(this.data));
      // 处理原始数据
      const listKey = this.type == 0 || this.type == 1 ? 'organizationList' : 'groupList';
      curData.commissionItems.forEach(item => {
        item.programBaseList.forEach(item2 => {
          item2[listKey].forEach(item3 => {
            let commssionList = item3.commissionInfoBeans;
            if (commssionList && commssionList.length) {
              commssionList = commssionList.sort((a, b) => {
                return a.commissionIndex > b.commissionIndex ? 1 : -1;
              });
              item3.commissionInfoBeans = commssionList;
            }
          });
        });
      });
      this.untilLast = curData.untilLastCommissionIndex > 0;
      this.dataBak = curData;
      this.dataBak2 = JSON.parse(JSON.stringify(curData));
      if (!this.dataBak.commissionItems) {
        return;
      }
      this.headList = this.data.programRules;
      this.activityList = this.data.acInfo;
      this.disabledAll = false;
      this.showNum = this.dataBak.commissionNum;
      if (this.dataBak.programRules) {
        this.cssNum = this.dataBak.programRules.length + this.showNum;
      } else {
        this.cssNum = this.showNum;
      }
      if (this.data.isDynamicRate) {
        this.cssNum += 2;
      }
      this.yearList = [];
      for (let index = 2; index <= this.showNum; index++) {
        this.yearList.push({
          text: '第' + this.$units.numberTransform(index) + '年',
          index
        });
      }
      this.$nextTick(() => {
        document.getElementById('body').style.width = document.getElementById('head').scrollWidth + 'px';
      });
      this.isAll = false;
    }
  },
  computed: {},
  created() {
    this.userType = JSON.parse(localStorage.getItem('userInfo')).userType;
  },
  methods: {
    getActivityNum(list, data) {
      if (list) {
        list = JSON.parse(list);
        const bean = list.find(item => item.id == data.id);
        return bean && bean.value * 1 ? bean.value : '-';
      } else {
        return '-';
      }
    },
    // 获取方案文本
    getKeyText(list, code) {
      const data = list.find(item => {
        return item.roleCode == code;
      });
      if (data && data.remark) {
        return data.remark;
      } else {
        return '-';
      }
    },
    // 保存修改
    save() {
      let data1 = this.saveData(JSON.parse(JSON.stringify(this.dataBak)));
      let data2 = this.saveData(JSON.parse(JSON.stringify(this.dataBak2)));
      if (JSON.stringify(data1) != JSON.stringify(data2)) {
        if (this.dataType == 2) {
          let data3 = this.saveData1(JSON.parse(JSON.stringify(this.dataBak)));
          this.$emit('save', data3);
        } else {
          this.$emit('save', data1);
        }
      } else {
        this.hideEdit();
      }
    },

    saveData1(data) {
      const arr = [];
      data.commissionItems.forEach(bean => {
        bean.programBaseList.forEach(item2 => {
          let commissionType = []
          let programCommissions = [];
          if (this.mode == 'base') {
            const list = item2.organizationList;
            programCommissions.push(this.pushData1(list[0], bean));
            commissionType= [list[0].commissionType]
          } else if (this.type == 1 || this.type == 0) {
            const list = item2.organizationList;
            programCommissions.push(this.pushData1(list[1], bean));
            commissionType= [list[1].commissionType]
          } else {
            const list = item2.groupList;
            let list1 = this.pushData1(list[1], bean);
            let list2 = this.pushData1(list[2], bean);
            programCommissions.push(list1, list2);
            commissionType = [list[1].commissionType,list[2].commissionType]
          }
          programCommissions.forEach((l,idx) => {
            arr.push({
              gradeCode: bean.isMain == '1' ? '00' : bean.programBaseList[0].gradeCode,
              isMain: bean.isMain == '1',
              programId: item2.factors[0].programId,
              commissionType:commissionType[idx],
              programCommissions: l
            });
          });
        });
      });
      return { list: arr, productCode: data.productCode };
    },

    // 合成提交数据
    pushData1(bean, product) {
      let arr = [];
      bean.commissionInfoBeans.forEach((item, i) => {
        arr.push(item);
      });
      return arr;
    },
    // 获取当前待保存数据
    getSaveData() {
      const data1 = this.saveData(JSON.parse(JSON.stringify(this.dataBak)));
      const data2 = this.saveData(JSON.parse(JSON.stringify(this.dataBak2)));
      if (JSON.stringify(data1) != JSON.stringify(data2)) {
        return data1;
      } else {
        return false;
      }
    },
    saveData(data) {
      const arr = [];
      data.commissionItems.forEach(bean => {
        bean.programBaseList.forEach(item2 => {
          if (this.mode == 'base') {
            const list = item2.organizationList;
            this.pushData(arr, list[0], list);
          } else if (this.type == 1 || this.type == 0) {
            const list = item2.organizationList;
            this.pushData(arr, list[1], list);
          } else {
            const list = item2.groupList;
            this.pushData(arr, list[1], list);
            this.pushData(arr, list[2], list);
          }
        });
      });
      return { list: arr, productCode: data.productCode };
    },
    // 合成提交数据
    pushData(arr, bean, parentList) {
      bean.commissionInfoBeans.forEach((item, i) => {
        const parent = parentList[0]['commissionInfoBeans'][i];
        if (parent) {
          item.parentValue = parent.value;
          if (this.pageType == 'merchant' && this.dataBak.isArbitrageSpace == 1) {
            item.parentArbitrageSpacePostfRateValue = parent.arbitrageSpacePostfRateValue;
          }
        }
        this.defaultData(arr, item);
      });
    },
    // 处理空值
    defaultData(arr, data) {
      if (data.value == '') {
        data.value = 0;
      }
      arr.push(data);
    },
    // 选中事件
    selectChange() {
      const selectArr = [];
      let isLongOrShort = [false, false];
      this.dataBak.forEach(item => {
        if (item.select) {
          //是否选中
          selectArr.push(item.productCode);
          if (item.productType == 1) {
            isLongOrShort[0] = true;
          } else {
            isLongOrShort[1] = true;
          }
        }
      });
      this.$emit('onSelectChange', selectArr, isLongOrShort);
    },
    // 显示编辑框 外部调用
    showEdit() {
      this.dataBak.commissionItems.forEach(item => {
        this.$set(item, 'edit', true);
      });
    },
    // 隐藏编辑框 外部调用
    hideEdit() {
      this.dataBak.commissionItems.forEach(item => {
        this.$set(item, 'edit', false);
      });
      this.dataBak = JSON.parse(JSON.stringify(this.data));
      this.$emit('hideEdit');
    },
    cancel(item) {
      this.$set(item, 'edit', false);
      this.dataBak = JSON.parse(JSON.stringify(this.data));
    },
    swapItems(index1, index2, type, secIndex) {
      if (type == 1) {
        this.dataBak.commissionItems[index1] = this.dataBak.commissionItems.splice(index2, 1, this.dataBak.commissionItems[index1])[0];
      } else {
        this.dataBak.commissionItems[index1].programBaseList[secIndex] = this.dataBak.commissionItems[index1].programBaseList.splice(
          index2,
          1,
          this.dataBak.commissionItems[index1].programBaseList[secIndex]
        )[0];
      }
      this.saveSort();
    },
    //type 1 险种排序 2 方案排序
    upData(type, index, secIndex = 0) {
      this.swapItems(index, type == 1 ? index - 1 : secIndex - 1, type, secIndex);
    },
    downData(type, index, secIndex = 0) {
      this.swapItems(index, type == 1 ? index + 1 : secIndex + 1, type, secIndex);
    },
    saveSort() {
      if (this.sortType == 'normal') {
        const arr = [];
        const data = JSON.parse(JSON.stringify(this.dataBak));
        data.commissionItems.forEach(bean => {
          console.log('bean', bean);
          bean.programBaseList.forEach(item2 => {
            if (this.mode == 'base') {
              const list = item2.organizationList;
              this.pushData(arr, list[0], list);
            } else if (this.type == 1 || this.type == 0) {
              const list = item2.organizationList;
              this.pushData(arr, list[1], list);
            } else {
              const list = item2.groupList;
              this.pushData(arr, list[1], list);
              this.pushData(arr, list[2], list);
            }
          });
        });
        this.$emit('changeSort', { list: arr, productCode: data.productCode });
      } else {
        const arr = [];
        const data = JSON.parse(JSON.stringify(this.dataBak));
        data.commissionItems.forEach(bean => {
          console.log('bean', bean);
          let arr1 = bean.programBaseList.map(i => {
            return {
              sortGradeCode: i.gradeCode,
              sortProgramId: i.id,
              isMain: bean.isMain
            };
          });
          arr.push(...arr1);
        });
        this.$emit('changeSort', { list: arr, productCode: data.productCode });
      }
    },
    // 删除交费年限
    delYear(bean) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '请确认是否删除？'
        })
        .then(() => {
          const params = {
            productCode: this.data.productCode,
            commissionIndex: bean.index
          };
          this.$emit('delYear', params);
        });
    },
    // 新增交费年限
    addYear(bean) {
      const commissionList = [];
      this.data.commissionItems.forEach(item => {
        item.programBaseList.forEach(item2 => {
          commissionList.push({
            isMain: item.isMain,
            gradeCode: item2.gradeCode,
            programId: item2.id,
            commission: 0
          });
        });
      });
      const params = {
        productCode: this.data.productCode,
        commissionIndex: bean.index + 1,
        commissionList
      };
      this.$emit('addYear', params);
    },
    // 是否至交费期满
    setFullYear(bean) {
      const params = {
        productCode: this.data.productCode,
        commissionIndex: bean.index,
        untilLast: this.untilLast
      };
      this.$emit('setFullYear', params);
    }
  }
};
</script>
<style lang="scss" scoped>
@import './rateTable.scss';
</style>